<template>
  <div class="m-market-single-line">
    <template v-for="outcomeId in market.outcomes.order">
      <div
        :key="outcomeId"
        class="m-market-row"
      >
        <div class="m-outcome m-outcome-desc">
          <span class="m-outcome-desc-name">{{ market.outcomes.map[outcomeId].description }}</span>
        </div>
        <Outcome
          :outcome="market.outcomes.map[outcomeId]"
          :market="market"
          :event="event"
        />
      </div>
    </template>
  </div>
</template>

<script>
/**
 * 三、每行只放一个selection
 * 规则描述：对于一些desc名称较长（现有排版，desc需换行）的Market，每行只放一个selection；
 * 要求：针对outcome名称方式较长，现有排列方式需要换行的market；
 */

import Outcome from 'wap/match/Event/pagelet/Outcome'

export default {
  name: 'Market3SingleLine',
  components: {
    Outcome
  },
  props: {
    market: {
      type: Object,
      default: () => ({})
    },
    event: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
